import SignaturePad from 'signature_pad';



const signaturePad = () => {

  function resizeCanvas(canvas) {
    var ratio =  Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
  }

  const canvas = document.querySelector('canvas.signaturePad');
  const restart = document.querySelector('.restart');
  const inputField = document.querySelector('#signatureField');
  const button = document.querySelector('.save-wrapper button');

  if (canvas) {
    if (button) {
      canvas.height = canvas.offsetHeight;
      canvas.width = canvas.offsetWidth;
      window.onresize = resizeCanvas(canvas);
      resizeCanvas(canvas);
    }

    const signaturePad = new SignaturePad(canvas, {
      onEnd: function() {
        inputField.value = signaturePad.toDataURL();
        if (button && !signaturePad.isEmpty()) {
          button.disabled = false;
        }
      }
    });
    restart.addEventListener('click', () => {
      signaturePad.clear();
    })
  }
}

export default signaturePad;
